<template>
    <div class="btn-group btn-group-vertical w-100" role="group" aria-label="Basic example">

      <router-link to="/conta/resumo" type="button" class="btn btn-outline-dark btn-sm w-100 mb-3 text_12 text_bold" v-bind:class="{ativado: num==1}">
        RESUMO DA CONTA
      </router-link>

      <router-link to="/conta/dados" type="button" class="btn btn-outline-dark btn-sm w-100 mb-3 text_12 text_bold" v-bind:class="{ativado: num==2}">
        MINHA CONTA
      </router-link>

      <router-link to="/conta/extrato/torneio" type="button" class="btn btn-outline-dark btn-sm w-100 mb-3 text_12 text_bold" v-bind:class="{ativado: num==3}">
        EXTRATO
      </router-link>

      <router-link to="/conta/deposito" type="button" class="btn btn-outline-dark btn-sm w-100 mb-3 text_12 text_bold" v-bind:class="{ativado: num==4}">
        DEPOSITAR POR PIX
      </router-link>

      <router-link to="/conta/saque" type="button" class="btn btn-outline-dark btn-sm w-100 mb-3 text_12 text_bold" v-bind:class="{ativado: num==5}">
        SACAR POR PIX
      </router-link>

      <router-link to="/conta/auto_exclusao" type="button" class="btn btn-outline-dark btn-sm w-100 mb-3 text_12 text_bold" v-bind:class="{ativado: num==6}">
        AUTO - EXCLUSÃO
      </router-link>

      <!-- <router-link to="/conta/verificada" type="button" class="btn btn-outline-dark btn-sm w-100 mb-3 text_12 text_bold" v-bind:class="{ativado: num==7}">
        VERIFICAR A CONTA
      </router-link> -->

      <router-link to="/conta/convite/historico" type="button" class="btn btn-outline-dark btn-sm w-100 mb-3 text_12 text_bold" v-bind:class="{ativado: num==8}">
        CONVIDADO
      </router-link>

    </div>
</template>

<script>
  export default {
    props: {
      num: {
      type: Number,
      required: true,
      default: 0
      }
    },
  }
</script>

<style scoped>

  .btn-outline-dark{
    padding: 10px 0 10px 0;
    color: #ffffff80;
    border: 1px solid #FFFFFF80;
  }

  .ativado{
    background-color: green; color:#fff;
    border: none;
  }

</style>


// WEBPACK FOOTER //
// src/components/conta/menu_conta.vue